import { render, staticRenderFns } from "./Bubble.global.vue?vue&type=template&id=b9575ea6&scoped=true&lang=pug&"
import script from "./Bubble.global.vue?vue&type=script&lang=ts&"
export * from "./Bubble.global.vue?vue&type=script&lang=ts&"
import style0 from "./Bubble.global.vue?vue&type=style&index=0&id=b9575ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9575ea6",
  null
  
)

export default component.exports